import Vue from 'vue'
import VueRouter from 'vue-router'
import LandingPage from '../views/LandingPage.vue'
import ChatPage from '@/views/ChatPage.vue'
import axios from 'axios'

Vue.prototype.$axios = axios

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'LandingPage',
        component: LandingPage
    },
    {
        path: '/chat',
        name: 'ChatPage',
        component: ChatPage
    },
    {
        path: '/image',
        name: 'ImagePage',
        component: () => import('../views/ImagePage.vue'),
    },
    {
        path: '/settings',
        name: 'SettingsPage',
        component: { render: h => h('div', 'Configurações em breve!') },
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

// Global navigation guard for protected routes
router.beforeEach(async (to, from, next) => {
    // Define protected routes
    const protectedRoutes = ['/chat', '/image'];
    if (protectedRoutes.includes(to.path)) {
        const token = localStorage.getItem('bearerToken');
        if (!token) {
            return next('/');
        }
        try {
            console.log('Validating token:', token);
            if (localStorage.getItem('bearerToken') === 'xxx')
                return next();
            else
                return next('/');
            // // Replace with your real validation endpoint
            // let url = 'https://direcionatech-api.otcscripts.workers.dev/validate';
            // // let url = 'http://localhost:8787/validate';
            // console.log(axios)
            // const response = await axios.get(url, {
            //     headers: { Authorization: `Bearer ${token}` }
            // });
            // if (response.status === 200 && response.data.valid) {
            //     return next();
            // } else {
            //     localStorage.removeItem('bearerToken');
            //     return next('/');
            // }
        } catch (e) {
            localStorage.removeItem('bearerToken');
            return next('/');
        }
    } else {
        return next();
    }
});

export default router
